export default __webpack_public_path__ + "static/media/mobile_newsfeed.682bfcdb.png";